import { User } from '../services/firebaseAuth';

// Permission levels
export const PERMISSIONS = {
  OWNER: 'owner',
  ADMIN: 'admin',
  TRADER: 'trader',
  USER: 'user'
} as const;

// Check if user can manage other users
export const canManageUsers = (userRole: User['role']): boolean => {
  return userRole === 'owner' || userRole === 'admin';
};

// Check if user can assign admin role
export const canAssignAdminRole = (userRole: User['role']): boolean => {
  return userRole === 'owner';
};

// Check if user can assign owner role
export const canAssignOwnerRole = (userRole: User['role']): boolean => {
  return userRole === 'owner';
};

// Check if user can approve users
export const canApproveUsers = (userRole: User['role']): boolean => {
  return userRole === 'owner' || userRole === 'admin';
};

// Check if user can reject users
export const canRejectUsers = (userRole: User['role']): boolean => {
  return userRole === 'owner' || userRole === 'admin';
};

// Check if user can suspend users
export const canSuspendUsers = (userRole: User['role']): boolean => {
  return userRole === 'owner' || userRole === 'admin';
};

// Get available roles for a user to assign
export const getAvailableRoles = (currentUserRole: User['role']): User['role'][] => {
  switch (currentUserRole) {
    case 'owner':
      return ['user', 'trader', 'admin', 'owner'];
    case 'admin':
      return ['user', 'trader', 'admin'];
    case 'trader':
    case 'user':
    default:
      return [];
  }
};

// Get role display name
export const getRoleDisplayName = (role: User['role']): string => {
  switch (role) {
    case 'owner':
      return 'Owner';
    case 'admin':
      return 'Admin';
    case 'trader':
      return 'Trader';
    case 'user':
      return 'User';
    default:
      return 'Unknown';
  }
};

// Get role description
export const getRoleDescription = (role: User['role']): string => {
  switch (role) {
    case 'owner':
      return 'Full system access, can create other owners and admins';
    case 'admin':
      return 'User management, can approve users and assign roles (except owner)';
    case 'trader':
      return 'Trading platform access with advanced features';
    case 'user':
      return 'Basic platform access';
    default:
      return 'Unknown role';
  }
};
